/* eslint-disable */
import React from 'react';
// import PropTypes from 'prop-types';

import ReceiptTear from 'assets/images/receipt-tear.png';
import { formatCurrency, parseNumber } from 'modules/common/utils';

function PrintTemplate({
  branchName,
  businessName,
  businessLogo,
  cart,
  includes,
  address,
  paymentMethod,
  amountTendered,
  change,
  data,
}) {
  return (
    <div
      style={{
        // position: 'absolute',
        width: 320,
        // top: '50%',
        // left: '50%',
        // transform: 'translate(-50%, -50%)',
        padding: '15px 0px',
      }}
    >
      <img src={ReceiptTear} alt="" width="100%" height="36px" />

      <div
        style={{
          borderLeft: '#ddd 1px solid',
          borderRight: '#ddd 1px solid',
          position: 'relative',
          padding: '15px 25px',
        }}
      >
        <div>
          <div
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {businessName}{' '}
            {branchName ? (
              <span style={{ color: 'red' }}>- {branchName}</span>
            ) : (
              ''
            )}
          </div>
          <div
            style={{
              textAlign: 'center',
              color: '#777',
              paddingTop: 5,
              fontSize: '10px',
            }}
          >
            {address}
          </div>
        </div>

        <br />

        <div>
          <hr style={{ border: '1px solid #ddd', borderStyle: 'dashed' }} />

          <br />

          <div>
            {cart?.length > 0 ? (
              <div>
                <div style={{ marginBottom: 5 }}>
                  <div
                    style={{
                      width: '80%',
                      display: 'inline-block',
                      verticalAlign: 'top',
                      fontSize: '15px',
                      fontWeight: 'bold',
                    }}
                  >
                    Items Ordered
                  </div>
                  <div
                    style={{
                      width: '20%',
                      display: 'inline-block',
                      verticalAlign: 'top',
                      fontSize: '15px',
                      fontWeight: 'bold',
                      textAlign: 'right',
                    }}
                  >
                    Price
                  </div>
                </div>

                {cart?.map((item, key) => (
                  <div key={key}>
                    <div
                      style={{
                        width: '80%',
                        marginBottom: 5,
                        display: 'inline-block',
                        verticalAlign: 'top',
                        fontSize: '14px',
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          minWidth: '25px',
                          display: 'inline-block',
                          verticalAlign: 'top',
                        }}
                      >
                        {item?.quantity}x
                      </div>
                      <div
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'top',
                        }}
                      >
                        <div>{item?.name}</div>
                        <div>
                          <div style={{ color: '#999', fontSize: '11px' }}>
                            <div style={{ textTransform: 'capitalize' }}>
                              {item?.code}
                            </div>
                            {item?.addOns?.map((item, key) => (
                              <div key={key}>
                                + {item?.name} ~{' '}
                                {formatCurrency(parseNumber(item?.price) || 0)}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: '20%',
                        display: 'inline-block',
                        verticalAlign: 'top',
                        textAlign: 'right',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        {item?.price_human}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: '#ddd' }}>
                <i>No items in this order...</i>
              </div>
            )}
          </div>

          <br />

          <hr style={{ border: '1px solid #ddd', borderStyle: 'dashed' }} />

          <div
            style={{
              fontSize: '13px',
              padding: '10px 0 10px 0',
            }}
          >
            <div style={{ marginBottom: 2 }}>
              <div
                style={{
                  width: '70%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                Subtotal
              </div>
              <div
                style={{
                  width: '30%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  textAlign: 'right',
                }}
              >
                {data?.subtotal}
              </div>
            </div>

            <div style={{ marginBottom: 2 }}>
              <div
                style={{
                  width: '70%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                Discount
              </div>
              <div
                style={{
                  width: '30%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  textAlign: 'right',
                }}
              >
                {data?.discount}
              </div>
            </div>

            <div style={{ padding: '10px 0 10px 0' }}>
              <hr style={{ border: '1px solid #ddd', borderStyle: 'dashed' }} />
            </div>

            {data?.chargesList?.map((item) => (
              <div style={{ marginBottom: 2 }}>
                <div
                  style={{
                    width: '70%',
                    display: 'inline-block',
                    verticalAlign: 'top',
                  }}
                >
                  {item?.name}
                </div>
                <div
                  style={{
                    width: '30%',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    textAlign: 'right',
                  }}
                >
                  {formatCurrency(item?.value || 0) || '-'}
                </div>
              </div>
            ))}

            <div style={{ marginBottom: 2 }}>
              <div
                style={{
                  width: '70%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                VAT ({data?.totalVAT}%)
              </div>
              <div
                style={{
                  width: '30%',
                  display: 'inline-block',
                  textAlign: 'right',
                  verticalAlign: 'top',
                }}
              >
                {data?.VAT}
              </div>
            </div>
          </div>

          <hr style={{ border: '1px solid #ddd', borderStyle: 'dashed' }} />

          <div style={{ fontSize: '14px', padding: '10px 0 10px 0' }}>
            <div
              style={{
                width: '60%',
                textAlign: 'right',
                display: 'inline-block',
                verticalAlign: 'top',
              }}
            >
              Total
            </div>
            <div
              style={{
                width: '40%',
                textAlign: 'right',
                display: 'inline-block',
                verticalAlign: 'top',
                fontWeight: 'bold',
                fontSize: '17px',
              }}
            >
              {data?.total}
            </div>
          </div>

          <hr style={{ border: '1px solid #ddd', borderStyle: 'dashed' }} />

          <br />

          <div
            style={{
              fontSize: '14px',
            }}
          >
            <div style={{ marginBottom: 2 }}>
              <div
                style={{
                  width: '70%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  fontWeight: 'bold',
                }}
              >
                Payment
              </div>
              <div
                style={{
                  width: '30%',
                  textAlign: 'right',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  fontWeight: 'bold',
                }}
              >
                {paymentMethod || '-'}
              </div>
            </div>

            <div style={{ marginBottom: 2 }}>
              <div
                style={{
                  width: '70%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                Amount Tendered
              </div>
              <div
                style={{
                  width: '30%',
                  textAlign: 'right',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                {formatCurrency(amountTendered) || '-'}
              </div>
            </div>

            <div style={{ marginBottom: 2 }}>
              <div
                style={{
                  width: '70%',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                Change
              </div>
              <div
                style={{
                  width: '30%',
                  textAlign: 'right',
                  display: 'inline-block',
                  verticalAlign: 'top',
                }}
              >
                {formatCurrency(change) || '-'}
              </div>
            </div>
          </div>
        </div>
      </div>

      <img
        src={ReceiptTear}
        alt=""
        width="100%"
        height="36px"
        style={{
          transform: 'rotate(180deg)',
        }}
      />
    </div>
  );
}

PrintTemplate.defaultProps = {};

PrintTemplate.propTypes = {};

export default PrintTemplate;
